import { fromJS } from 'immutable'

export default fromJS({
  questions: {
    noAlt: 'Texto alternativo ausente para esta imagem',
    noAnswers: 'Nenhuma opção de resposta. Clique em avançar para continuar.',
    placeholder: 'Por favor, especifique…',
    pleaseSelect: 'Por favor, selecione…',
    rotateLandscape: 'Desative o bloqueio de orientação no seu celular e gire para horizontal para continuar.',
    rotatePortrait: 'Gire o celular da horizontal para a vertical para continuar.',
    ir: {
      selectWebCam: "Selecione a webcam (se disponível) ou clique em 'Procurar' para carregar de seu dispositivo",
      noWebCam: 'Nenhuma webcam detectada',
      accessCamUpload: 'ACESSAR CÂMERA/CARREGAR',
      browse: 'PROCURAR',
      uploadPhoto: 'Carregar foto',
      instead: 'ao invés',
      capture: 'CAPTURAR',
      somethingWrong: 'Desculpe, ocorreu algum erro. Tente novamente mais tarde',
      couldntRead: 'Desculpe, não pudemos ler o código!',
      couldntProcess: 'Desculpe, não pudemos processar sua imagem!',
      moveOn: 'Tente novamente ou envie sua foto e prossiga',
      tryAgain: 'Por favor, tente novamente',
      dataReceived: 'Dados recebidos!',
      enterManually: 'Tente novamente ou insira os dados manualmente abaixo',
      positionQR:
        'Posicione o código QR na frente da sua câmera para encaixá-lo na moldura vermelha ou carregue do seu computador.',
      analyzing: 'Analisando a imagem. Aguarde, por favor',
      submit: 'ENVIAR',
      startOver: 'Comece novamente',
      allDone: 'Tudo pronto!',
      cantAnalyze:
        'Atenção - não foi possível renderizar esta imagem. Tente reenviar ou selecione um formato de imagem mais genérico (JPG, PNG, GIF, BMP)',
      wrongFormat:
        'Desculpe - não oferecemos suporte a este formato de arquivo. Faça upload de um tipo de imagem compatível (JPG, PNG, GIF, BMP, TIF, PDF, SVG)'
    },
    vr: {
      noWebCam: 'Nenhuma webcam detectada',
      uploadVideo: 'Upload um vídeo',
      skip: 'Pular?',
      accessCamUpload: 'ACESSAR CÂMERA/CARREGAR',
      browse: 'PROCURAR',
      instead: 'ao invés',
      or: 'ou',
      stopRecording: 'Parar a gravação',
      willBeStopped: 'A gravação irá parar em 5 minutos',
      stopOnDone: 'Pare a gravação quando terminar!',
      record: 'GRAVAR',
      somethingWrong: 'Desculpe, ocorreu algum erro. Tente novamente mais tarde',
      microphone: 'Microfone',
      camera: 'Webcam',
      selectMicrophone: 'Selecione seu microfone',
      selectCam: 'Selecione sua webcam',
      upload: 'Carregar',
      playback: 'Reprodução',
      stopPlayback: 'PARAR REPRODUÇÃO',
      submit: 'ENVIAR',
      startOver: 'Comece novamente',
      allDone: 'Tudo pronto!',
      alternativeRecordSpan: 'Carregue um videoclipe do seu computador.<br/>Co mo alternativa, &nbsp;',
      alrenativeRecordHref: 'você pode gravar o vídeo com ',
      cantAnalyze:
        'Atenção - não foi possível renderizar este vídeo. Tente reenviar ou selecione um formato de vídeo mais genérico (MP4, M4V, WEBPM)',
      wrongFormat:
        'Desculpe - não oferecemos suporte a este formato de arquivo. Faça upload de um tipo de vídeo compatível (MP4, AVI, M4V, WEBPM, MOV, MKV, MPG, WMV)'
    },
    cjc: {
      choose: 'SELECIONAR',
      pleaseChoose: 'Selecione',
      this: 'ESTE',
      one: 'um',
      myChoice: 'MINHA ESCOLHA'
    },
    hm: {
      addComment: 'Adicione um comentário abaixo',
      commentMandatoryPlaceHolder: 'Adicione um comentário obrigatório... ',
      commentOptionalPlaceHolder: 'Adicione um comentário opcional... ',
      dragPin: 'Arraste para reposicionar (clique/toque longo para fixar com precisão).',
      removePin: 'Arraste para fora da imagem para excluir.',
      editComment: 'Clique/toque no pino para editar o comentário.',
      addPin: 'Arraste o pino do painel abaixo e solte-o em um ponto de sua escolha na imagem.',
      addPins: 'Arraste os pinos do painel abaixo e solte-os em um ponto de sua escolha na imagem.',
      leavePins: (minPoints, maxPoints) =>
        `Deixe pelo menos ${minPoints}, mas no máximo ${maxPoints} pinos de todos os tipos.`,
      leavePinsPerPage: (minPoints, maxPoints) => `Deixe pelo menos ${minPoints}, mas no máximo ${maxPoints} pinos.`,
      leavePinsWithOff: maxPoints =>
        `Deixe no máximo ${maxPoints} pinos de cada tipo ou clique em Avançar para ignorar.`,
      leavePinsPerPageWithOff: maxPoints => `Deixe no máximo ${maxPoints} pinos ou clique em Avançar para ignorar.`,
      leavePinWithOff: 'Deixe no máximo 1 pino de cada tipo ou clique em Avançar para ignorar.',
      leavePinPerPageWithOff: 'Deixe no máximo 1 pino ou clique em Avançar para ignorar.',
      leaveExactlyPin: 'Deixe 1 pino de cada tipo.',
      leaveExactlyPinPerPage: 'Deixe 1 pino.',
      leaveExactlyPins: maxPoints => `Deixe ${maxPoints} pinos de cada tipo.`,
      leaveExactlyPinsPerPage: maxPoints => `Deixe ${maxPoints} pinos.`,
      leaveComment: 'Digite abaixo da imagem para deixar um comentário.',
      noAnswers: 'Opção sem resposta, clique em Avançar para continuar.',
      outOfPins: 'Seus pinos acabaram',
      pinsBehavior:
        'À medida que você se move pela imagem, verá áreas que serão destacadas com uma única queda de pino.',
      clusters: 'Você só poderá colocar pinos nessas áreas destacadas.',
      contentAware: 'Você pode soltar pinos dentro ou fora das áreas destacadas.'
    },
    mp: {
      expand_note: 'Passe o mouse sobre ou clique na(s) imagem(ns) para expandir',
      rb_note: rows => `Por favor, selecione apenas 1 resposta por item${rows ? ' abaixo' : ''}:`,
      cb_note: (min, max, rows) => {
        if (1 === min && 5000 === max) {
          return 'Marque todos os que se aplicam:'
        } else if (min === max) {
          return `Por favor, selecione ${min !== 1 ? 'quaisquer' : 'apenas'} ${min} reposta${
            min !== 1 ? 's' : ''
          } por item${rows ? ' abaixo' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Por favor, selecione pelo menos ${min} reposta${
            min !== 1 ? 's' : ''
          } mas não mais do que ${max} por item${rows ? ' abaixo' : ''}:`
        } else if (5000 === max && min > 0) {
          return `Por favor, selecione pelo menos ${min} reposta${min !== 1 ? 's' : ''} por item${
            rows ? ' abaixo' : ''
          }:`
        } else if (0 === min && max < 5000) {
          return `Por favor, selecione não mais do que ${max} reposta${max !== 1 ? 's' : ''} por item${
            rows ? ' abaixo' : ''
          }:`
        } else {
          return 'Marque todos os que se aplicam:'
        }
      }
    },
    sh: {
      note: 'Clique em um produto para ampliar o zoom e adicioná-lo ao seu carrinho virtual se deseja comprá-lo na loja',
      amazonNote: 'Clique em um produto para ampliar o zoom e adicioná-lo ao seu carrinho virtual.',
      fullCart: 'Seu carrinho está cheio!',
      qty: 'QTD',
      addToCart: 'ADICIONAR AO CARRINHO',
      deleteFromCart: 'EXCLUIR',
      each: 'cada',
      items: 'Unid',
      emptyCard: 'Seu carrinho está vazio',
      total: 'Carrinho',
      clearCart: 'Esvaziar carrinho',
      backToStore: 'Voltar para a loja',
      na: 'Nenhuma das acima',
      next: 'PRÓXIMO',
      maxCartCountError: max => `Adicione no máximo ${max} produtos ao seu carrinho `,
      scrollError: `Role totalmente para a esquerda e para a direita para continuar na pesquisa. `,
      maxSpentError: max => `Não gaste mais do que  ${max}.`,
      maxProductCountError: max => `Adicione no máximo  ${max} de cada produto ao seu carrinho.`
    },
    rb: {
      note: 'Por favor, selecione apenas 1 item:'
    },
    vo: {
      note: 'Assista ao vídeo até o final'
    },
    cb: {
      note: (min, max) => {
        if (min === max) {
          return `Por favor, selecione ${min !== 1 ? 'quaisquer' : 'apenas'} ${min} item${min !== 1 ? 's' : ''}:`
        } else if (min > 0 && max < 5000) {
          return `Por favor, selecione no mínimo ${min} item${min !== 1 ? 's' : ''} e no máximo ${max}:`
        } else if (5000 === max && min > 0) {
          return `Por favor, selecione no mínimo ${min} item${min !== 1 ? 's' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Por favor, selecione no máximo ${max} item${max !== 1 ? 's' : ''}:`
        } else {
          return 'Marque todos os que se aplicam:'
        }
      }
    },
    oe: {
      na: 'Não aplicáve',
      note: (min, max, optional) => {
        if (min === max) {
          return `Por favor, digite ${1 !== min ? 'quaisquer' : 'exatamente'} ${min} caractere${1 !== min ? 's' : ''}${
            optional ? ' (opcional)' : ''
          }:`
        } else if (min > 0 && max < 5000) {
          return `Por favor, digite no mínimo ${min} caractere${1 !== min ? 's' : ''} e no máximo ${max}${
            optional ? ' (opcional)' : ''
          }:`
        } else if (5000 === max && min > 0) {
          return `Por favor, digite no mínimo ${min} caractere${1 !== min ? 's' : ''}${optional ? ' (opcional)' : ''}:`
        } else if (0 === min && max < 5000) {
          return `Por favor, digite até ${max} caractere${1 !== min ? 's' : ''}${optional ? ' (opcional)' : ''}:`
        } else {
          return ''
        }
      }
    },
    oex: {
      note: 'Preencha os campos a seguir:'
    },
    mx: {
      note: 'Mova os controles deslizantes realçados para continuar',
      dragSlider: 'Arraste para a esquerda ou para a direita para responder'
    },
    psc: {
      dragLeftRight: 'Arraste para a esquerda ou para a direita para responder'
    },
    ps: {
      note: (value, remaining) => `Por favor, distribua ${remaining ? 'restantes' : ''} ${value} Entre os itens abaixo`,
      allDone: 'Tudo pronto!',
      total: `Total:`,
      dragSlider: 'Arraste para a esquerda ou para a direita para responder'
    },
    cx: {
      note: 'Comece a digitar a sua resposta para usar a rolagem automática ou selecione-o manualmente'
    },
    ro: {
      note: 'Arraste para cima ou para baixo para reordenar:'
    },
    md: {
      note1: 'Clique/toque no item selecionado primeiro<br/>Clique/toque novamente para apagar a seleção.',
      note2: 'Agora, clique/toque no item selecionado por último<br/>Clique/toque novamente para apagar a seleção.',
      note3:
        'Obrigado! Passe para a pergunta seguinte<br/>ou clique/toque em qualquer item não selecionado para começar de novo.'
    },
    aro: {
      note: 'Por favor, escolha um item para cada par.'
    },
    wd: {
      note: 'Certifique-se de que cada valor subsequente é maior do que o anterior.'
    },
    emd: {
      note: 'Assista ao vídeo até o final',
      noAnswers: 'Nenhuma opção de resposta. Clique em avançar para continuar.',
      start: 'Clique e segure para começar',
      resume: 'Clique e segure para recomeçar',
      continue: 'Você está pronto! <br />Clique em Avançar para continuar',
      continueMobile: 'Você está pronto! <br /> Clique AQUI para continuar',
      training: {
        session: 'Sessão de treinamento',
        note: 'Por favor, termine o treinamento',
        moveLeft: 'Arraste o seletor totalmente para a esquerda',
        moveBottom: 'Arraste o seletor totalmente para baixo',
        moveRight: 'Agora, arraste o seletor totalmente para a direita',
        moveTop: 'Agora, arraste o seletor totalmente para cima',
        success: 'Ótimo trabalho!'
      }
    },
    sft: {
      noAnswers: 'Nenhuma opção de resposta. Clique em avançar para continuar.',
      note: 'Responda o mais rápido possível com a resposta que você sentir que parece certa',
      finish: 'Tudo pronto! <br /> Clique em Avançar para continuar',
      training: {
        start:
          '<p>Esta questão exibe palavras diferentes rapidamente e exigirá sua concentração. ' +
          'Você precisará reagir rapidamente para responder. </p> <p>Pronto para praticar?</p>',
        step1: (touch, mouse, key) =>
          touch
            ? `Toque em "{buttonLeft}"`
            : (mouse ? `Clique em "{buttonLeft}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Pressione tecla "{keyBtnLeft}"` : ''),
        step2: (touch, mouse, key) =>
          touch
            ? `Toque em "{buttonRight}"`
            : (mouse ? `Clique em "{buttonRight}"` : '') +
              (key && mouse ? ' / ' : '') +
              (key ? `Pressione tecla "{keyBtnRight}"` : ''),
        fail: () => 'Lento demais',
        success: () => 'Excelente!',
        finish: () =>
          '<p><strong> Excelente!</strong></p><p>Certifique-se de que não<br />' +
          'se distrairá nos próximos 2-3 minutos. </p><p>Clique em Avançar para começar quando estiver pronto.</p>'
      },
      buttons: {
        start: 'Começar',
        yesno: {
          left: 'Sim',
          right: 'Não'
        },
        matches: {
          left: 'Combina',
          right: 'Não combina'
        },
        fits: {
          left: 'Encaixa',
          right: 'Não encaixa'
        },
        thumbs: {
          left: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsUp"></i>',
          right: '<i class="rfd-ui-button-icon icon-aytmfd-thumbsDown"></i>'
        }
      }
    }
  }
})
